import { render, staticRenderFns } from "./CreateBranchPage.vue?vue&type=template&id=93c9950a&scoped=true"
import script from "./CreateBranchPage.vue?vue&type=script&lang=js"
export * from "./CreateBranchPage.vue?vue&type=script&lang=js"
import style0 from "./CreateBranchPage.vue?vue&type=style&index=0&id=93c9950a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c9950a",
  null
  
)

export default component.exports